import React from "react";
import styled from "styled-components";
import { mobileQuery } from "./MediaQuery";

export const Separated: React.FC<{
  children: React.ReactNodeArray;
  className?: string;
}> = (props) => (
  <div className={props.className}>
    {props.children.map((child, index) => (
      <React.Fragment key={`separated-${index}`}>
        {child}
        {index == props.children.length - 1 ? null : <Separator>|</Separator>}
      </React.Fragment>
    ))}
  </div>
);

const Separator = styled.div`
  display: inline-block;
  margin: 0 8px;
  ${mobileQuery`
    margin: 0 12px;
  `}
`;
